import Immutable, { Map, Record } from 'immutable'
import fetchJSON from 'lib/fetchJSON'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { CREATE_GOAL, DELETE_GOAL } from 'lib/api/goals'
import { JOIN_GOAL, LEAVE_GOAL } from 'lib/api/goalParticipants'

export const LOAD_USER_GOALS = 'goalsForUser/LOAD_USER_GOALS'

const deserialize = (fromRails) => Immutable.fromJS(fromRails)

// TODO: delete this reducer entirely and fold its functionality into goalParticipants.js
export const reducer = (state = Record({ loaded: false, records: Map() })(), action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_USER_GOALS): {
      const rgp = deserialize(action.payload.user.relevant_goal_participants)
      return state.merge({ loaded: true, records: Map(rgp.map(gp => [gp.get('id'), gp])) })
    }
    case fulfilled(CREATE_GOAL): {
      const { payload } = action
      const gp = deserialize(payload.goal_participant)
      return state.set('records', state.records.set(gp.get('id'), gp))
    }
    case fulfilled(DELETE_GOAL): {
      const { goalId } = action.meta
      return state.set('records', state.records.filter(gp => gp.getIn(['goal', 'id']) !== goalId))
    }
    case fulfilled(JOIN_GOAL): {
      const { payload } = action
      const gp = deserialize(payload.goal_participant)
      return state.set('records', state.records.set(gp.get('id'), gp))
    }
    case fulfilled(LEAVE_GOAL): {
      const { participantId } = action.meta
      return state.set('records', state.records.delete(participantId))
    }
    default:
      return state
  }
}

// problem: we need to be able to display the public goals a friend is participating in
export const loadGoalsForUser = () => ({
  type: LOAD_USER_GOALS,
  payload: fetchJSON('/users/current.json?apikey=x&version=2')
})
